export default __webpack_public_path__ + "static/media/Beaugeard.495e6021.png";